import type {
  ProductCreateRequestOptionType,
  ProductCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useProductCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: ProductCreateRequestOptionType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `products`,
        data,
      }).then(
        (data) => apiV2AssertResponse(data).data as ProductCreateResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.StockOverview],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.ProductTemplate],
      });
      if (response.ParentId) {
        //sometimes we pull data from the parent, so we need to invalidate that too
        queryClient.invalidateQueries({
          queryKey: [business?.id, ServerStateKeys.Products, response.ParentId],
        });
      }
    },
  });
};
